export interface File {
    originalPath: string;
    relativePath: string;
    path: string;
    sourceMap: string;
}
